<template>
    <div>
        <div class="head">
            <div class="back-box" @click="goBack"><img class="icon" src="@/assets/icon_back.png" alt="back"><div>{{this.$t('head.back')}}</div></div>
            <div>{{this.$t('sztxmm.title')}}</div>
        </div>        
        <div class="bg">
            <ul class="list-box">                
                <!-- 提款密码 -->
                <li class="list">                
                    <div class="list-text">{{this.$t('sztxmm.t8')}}</div>
                    <input class="input" type="number" v-model="new_money_password" :placeholder="this.$t('sztxmm.t3')">
                </li>
                <!-- 确认提款密码 -->
                <li class="list">                
                    <div class="list-text">{{this.$t('sztxmm.t4')}}</div>
                    <input class="input" type="number" v-model="sure_new_money_password" :placeholder="this.$t('sztxmm.t3')">
                </li>   
                
                <button class="btn" type="button" @click="sure">{{this.$t('sztxmm.t6')}}</button>
            </ul>     
        </div>
    </div>
</template>
<script>
export default {
    name: 'notice',
    data () {
        return {            
            new_money_password: '',
            sure_new_money_password:''       
        }
    },
    methods: {
        sure(){
            let uid = localStorage.getItem('uid');
		    let token =localStorage.getItem('token');
            let reg=/^\d{4}$/;
            let params = {
                uid: uid,
                token: token,                               
                new_money_password: this.new_money_password
            }           

            if(this.new_money_password == '' || this.new_money_password == null){
                this.$toast.bottom(this.$t('sztxmm.t3'));
                return;
            }
            if(this.new_money_password != this.sure_new_money_password){
                this.$toast.bottom(this.$t('sztxmm.t7'));
                return;
            }

            this.$ajax.post('/api/user/moneyPasswordReset',params).then((res) => {                
                let resData = res.data.data; 
                if(res.data.ret == 200){
                    this.$toast.bottom(res.data.msg);
                    this.$router.push('/safety')
                }
            }).catch(function(err){
                console.log(err)
            })    
        },
        goBack(){
            this.$router.go(-1);
        },
        jump(){
            this.$router.push('/OnlineService')
        }
    }
}
</script>
<style scoped>
    .head{
        position: relative;
        height: .8rem;
        font-size: .28rem;
        line-height: .8rem;
        text-align: center;
    }
    .head .back-box{
        position: absolute;
        left: .2rem;
        display: flex;
        align-items: center;
    }
    .head .icon{
        width: .18rem;
        height: .3rem;
        margin-right: .1rem;        
    }   
    .bg{
        position: absolute;
        width: 100%;
        height: calc(100% - .8rem);
        background: #fff;
    }
    .list-box{
        margin-top: .2rem;
        padding: 0 .4rem;
        color: #000;
        background: #fff;
    }
    .list-box .list{
        display: flex;
        justify-content: flex-start;
        align-items: center;  
        padding: .2rem 0;
        font-size: .24rem;
        border-bottom: 1px solid #ccc;
    }
    .list-box .list-text{
        width: 1.6rem;      
    }
    .list-box .list .input{
        flex: 1;   
    }  
    .tips{
        margin-top: .2rem;
        color: #ff0000;
        font-size: .24rem;
        text-align: right;
    }
    .btn {
        width: 100%;
        height: .8rem;
        margin: .4rem 0;
        color: #fff;
        font-size: .24rem;
        line-height: .8rem;
        border-radius: 8px;
        background: #bcc170;
    }
</style>


// WEBPACK FOOTER //
// src/pages/setCashPwd.vue